// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mh2B","index":"styles_index__QgvvR"};